/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x1a40=['values','domConverter','markerNameToElements','view','name','mapper'];(function(_0x3ab975,_0x1a40e1){const _0x579207=function(_0x19b60c){while(--_0x19b60c){_0x3ab975['push'](_0x3ab975['shift']());}};_0x579207(++_0x1a40e1);}(_0x1a40,0x15a));const _0x5792=function(_0x3ab975,_0x1a40e1){_0x3ab975=_0x3ab975-0x0;let _0x579207=_0x1a40[_0x3ab975];return _0x579207;};import{first as _0x4a3800}from'ckeditor5/src/utils';export default function x(_0x200c8b,_0x4eb65f){const _0x2e5cf3=_0x200c8b[_0x5792('0x1')][_0x5792('0x4')](_0x4eb65f[_0x5792('0x0')]),_0x2dd1fb=_0x4a3800(_0x2e5cf3[_0x5792('0x2')]());return _0x200c8b[_0x5792('0x5')][_0x5792('0x3')]['mapViewToDom'](_0x2dd1fb);}